export interface ProductModule {
  id: string
  heading: string
  lead: string
  details: string[]
  note?: string
  linkLabel: string
  href: string
  index: string
}

export const productModules: ProductModule[] = [
  {
    id: 'starter-kits',
    index: 'A',
    heading: 'Starter Kits',
    lead: 'A matched entry point with the holder, inserts and service tools required for the published setup.',
    details: [
      'SG Kit 1″ — 1-inch holder system',
      'SG Kit 3/4″ — 3/4-inch holder system',
      'Each kit includes the matching holder, 10 APGX 331R inserts, a Torx driver and extra screws.',
    ],
    linkLabel: 'View Starter Kits',
    href: '/products/starter-kits/',
  },
  {
    id: 'holders',
    index: 'B',
    heading: 'Tool Holders',
    lead: 'Rigid external holders for the two published shank sizes.',
    details: [
      'SALXR 16-3D — 1-inch shank',
      'SALXR 12-3B — 3/4-inch shank',
      'Uses low-profile insert screws and a T-15 Torx driver.',
    ],
    linkLabel: 'View Tool Holders',
    href: '/products/holders/',
  },
  {
    id: 'inserts',
    index: 'C',
    heading: 'Inserts & Chipbreakers',
    lead: 'Published APGX configurations for roughing, chip control and titanium-oriented applications.',
    details: [
      'APGX 331R MG12 — .016″ radius',
      'APGX 332R MG12 — .031″ radius',
      'APGX 333R MG12 — .047″ radius',
      'APGX 331-30R MG12 chipbreaker — .016″ radius',
      'APGX 332-30R MG12 chipbreaker — .031″ radius',
      'APGX 331R DR80 honed/MAX coated — .016″ radius',
      'APGX 332R DR80 honed/MAX coated — .031″ radius',
    ],
    note: 'Inserts are sold in full boxes of 10. Call 800-397-7745 for pricing and availability.',
    linkLabel: 'View Inserts',
    href: '/products/inserts/',
  },
  {
    id: 'accessories',
    index: 'D',
    heading: 'Accessories',
    lead: 'Service items for installation and replacement.',
    details: ['T-15 Torx driver', '4-15 low-profile insert screws'],
    linkLabel: 'View Accessories',
    href: '/products/accessories/',
  },
]

export interface ApplicationCard {
  heading: string
  copy: string
  technicalLabel: string
  linkLabel: string
  href: string
  image: string
  imageAlt: string
  objectPosition: string
}

export const applicationCards: ApplicationCard[] = [
  {
    heading: 'Aluminum',
    copy: 'For 6061-T6, the published system separates high-feed roughing from lower-feed chipbreaker applications.',
    technicalLabel: 'MG12 ROUGHING / -30R CHIPBREAKER',
    linkLabel: 'Explore Aluminum Applications',
    href: '/applications/aluminum/',
    image:
      'https://cdn.magicpatterns.com/uploads/cMC8YcrkQ9vPHG2zmWfVcj/rp-application-aluminum.png',
    imageAlt:
      'Illustrative close-up of CNC turning aluminum with a controlled silver chip.',
    objectPosition: '62% center',
  },
  {
    heading: 'Copper & Soft Alloys',
    copy: 'The published guidance calls for a peck cycle for chip control in copper and soft aluminum alloys, with specific starting values for oxygen-free copper.',
    technicalLabel: 'POLISHED MG12 INSERTS',
    linkLabel: 'Explore Copper & Soft Alloys',
    href: '/applications/copper-soft-alloys/',
    image:
      'https://cdn.magicpatterns.com/uploads/oV3g2ZCCDSeyn6JRqBJMQ6/rp-application-copper.png',
    imageAlt:
      'Illustrative close-up of CNC turning copper with controlled copper curls.',
    objectPosition: '50% center',
  },
  {
    heading: 'Titanium',
    copy: 'Published DR80 honed and MAX-coated configurations use a more conservative speed and feed starting range.',
    technicalLabel: 'DR80 HONED / MAX COATED',
    linkLabel: 'Explore Titanium Applications',
    href: '/applications/titanium/',
    image:
      'https://cdn.magicpatterns.com/uploads/kyzgWkHq1iAo55kUGdm535/rp-application-titanium.png',
    imageAlt:
      'Illustrative close-up of CNC turning titanium with a compact heat-tinted chip.',
    objectPosition: '45% center',
  },
]
